module.exports = __webpack_public_path__ + "media/images/missing-product-image-4201774a2adabff11c378341cf3e906a.svg";